import { STYLE_PALE, Tag } from '@eventbrite/eds-tag';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { PublicCollectionsCamel } from '../../types/collections';
import { CollectionMembershipView } from './CollectionMembershipView';
import { useExpandCreatorCollections } from './hooks';

interface EventCardCollectionMembershipProps {
    collections?: PublicCollectionsCamel;
    eventId: string;
    style?: React.CSSProperties;
    className?: string;
    onCollectionClick?: (id: string) => void;
}

export const EventCardCollectionMembership: React.FunctionComponent<
    EventCardCollectionMembershipProps
> = (props) => {
    const collections = props.collections?.creatorCollections;

    const [isCollectionViewActive, setIsCollectionViewActive] =
        React.useState<boolean>(false);

    const { data: expandedCreatorCollections } = useExpandCreatorCollections(
        props.eventId,
        { enabled: isCollectionViewActive },
    );

    const handleToggleCollectionView = () => {
        setIsCollectionViewActive(
            (isCollectionViewActive) => !isCollectionViewActive,
        );
    };
    const handleCollectionClick = (id: string) => {
        props.onCollectionClick?.(id);
    };

    if (!collections?.objectCount) {
        return null;
    }

    return (
        <div
            className={`event-card__collection-membership ${
                props.className ? props.className : ''
            }`}
            data-testid="collection-signal"
            data-subcontent-key="collection"
            style={{
                position: 'relative',
                ...(props.style ? props.style : {}),
            }}
        >
            <Tag
                style={STYLE_PALE}
                onActiveToggle={() => handleToggleCollectionView()}
                initialIsActive={isCollectionViewActive}
                __containerClassName="ignore-react-onclickoutside"
            >
                <span style={{ fontSize: '12px', lineHeight: '16px' }}>
                    {typeof collections?.objectCount == 'number' &&
                    collections.objectCount > 1
                        ? gettext(
                              'Featured in %(collectionCount)s collections',
                              {
                                  collectionCount: collections.objectCount,
                              },
                          )
                        : gettext('Featured in a collection')}
                </span>
            </Tag>
            {isCollectionViewActive && (
                <CollectionMembershipView
                    isCollectionViewActive={isCollectionViewActive}
                    collections={
                        expandedCreatorCollections?.creatorCollections ||
                        collections
                    }
                    setIsCollectionViewActive={() =>
                        handleToggleCollectionView()
                    }
                    onCollectionClick={handleCollectionClick}
                />
            )}
        </div>
    );
};
